export default "__VITE_ASSET__DSsehnWG__"